<template>
  <sc-overlay v-if="value" :is-centered="true">
    <v-progress-circular
      indeterminate
      :size="64"
      :width="4"
      color="primary"
    ></v-progress-circular>
  </sc-overlay>
</template>

<script>
export default {
  name: 'TheLoadingOverlay',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
